/**
 * Storage keys Brand Setup owns.
 *
 * Its own right file: the Adjust journal's draft key used to live on the
 * screen that happened to mount the Studio first, which made deleting that
 * screen a cross-cutting change instead of a deletion.
 */

/** Draft key for the Adjust (OnboardingStudio) journal — `clearOnboardingDesignDraft`. */
export const BRAND_SETUP_DRAFT_KEY = "brand-setup";

/**
 * The label the Adjust journal's first entry carries when it was built from
 * the wizard's own step choices. It is the RESEED's anchor — only an entry
 * with this label is ever rebuilt or skipped when the operator's own work is
 * counted — and the phone beside the steps replays the same patch under the
 * same name, so the preview and the editor cannot disagree about what the
 * wizard decided.
 */
export const SEED_ENTRY_LABEL = "Your choices so far";
